var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    x: 0.5,
    y: 0.5,
    fill: "#F9FAFA",
    stroke: "#E5E9EC",
    strokeDasharray: "2 2",
    rx: 7.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M26 37h4M26 19h4M19 26v4M37 26v4M23 37a4 4 0 0 1-4-4v0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M23 37a4 4 0 0 1-4-4v0M33 19a4 4 0 0 1 4 4v0M19 23a4 4 0 0 1 4-4v0M37 33a4 4 0 0 1-4 4v0M25.5 27.5 28 25l2.5 2.5M28 25v6"
  })));
};
export { SvgUpload as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNzZjMWQ3OTY1N2I0NzNkODAxMDFiMGFiOTJjZDUwNTAuc3ZnIjs=";